function getSpecValue(html, key) {
    const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // 匹配spec-label下的strong内容
    const regex = new RegExp(`class="spec-label">\\s*${escapedKey}\\s*<\\/div>[\\s\\S]*?<strong>([\\s\\S]*?)<\\/strong>`, 'i');
    const match = html.match(regex);
    return match ? match[1].trim() : null;
}